<template lang="pug">
    .play-box
        template(v-if='!isLoading')
                game-header(
                    v-if="!isBattle"
                    @soundStateChanged ="headerKey = !headerKey"
                    :key="headerKey"
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .warning(v-if='(isOrientationChanged && !gameFinished)')
                    svg#rotate(
                        version='1.1'
                        xmlns='http://www.w3.org/2000/svg'
                        x='0px' y='0px' width='40px'
                        height='40px' viewbox='0 0 612 612'
                        style='enable-background:new 0 0 612 612;'
                        xml:space='preserve'
                    )
                        no-phone-icon

                    div(v-if="isOrientationChanged")
                        | {{ $i18n.t('trainer.trainer_games_rotateScreenMessage') }}
                .play-box__game(v-if='!isOrientationChanged && gameStarted && !gameFinished')
                    .play-box__example
                        template
                            .play-box__overflow-container
                                div(:style="wordStyle")
                                    .play-box__user_answers(v-if="userAnswers.length")
                                        .play-box__user_answer(
                                            v-for="userAnswer in userAnswers"
                                            :is="userAnswer.component",
                                            :style="getStylesForElements(userAnswer)"
                                            :elemWidth="userAnswer.width"
                                            :elemHeight="letterBlockHeight"
                                        )
                                    .play-box__user_answers(v-if="nullableEndingChosen")
                                        .play-box__user_answer(
                                            :is="'nullableEnding'"
                                            :style="getStylesForNullableEnding()"
                                            :elemWidth="this.$refs.letterBlocks[0].offsetWidth"
                                        )
                                    .play-box__whole_words(v-if="wholeWordForCurrentExample")
                                        .play-box__whole_word(
                                                v-for="(wordItem, index) in wholeWordForCurrentExample"
                                                @click="chooseLetter(wordItem, index)"
                                                ref="letterBlocks"
                                                :class="{'chosen': wordItem.isChosen}"
                                                :style="{color: wordItem.isCorrect && 'hsl(121, 38%, 58%)' || '#333333'}"
                                            ) {{ wordItem.letter }}
                                .play-box__answers-field
                                    .play-box__answer(
                                            v-for="(item, index) in possibleAnswers"
                                            :key="index",
                                            @click="chooseUserAnswer(item)",
                                        )
                                        div(:is="item")
                                cs-button.play-box__next-example-button(
                                    v-if="!isDictationMode && !isCorrectAnswerChosen",
                                    @click="clearUncheckedAnswers",
                                    pattern="primary-outline",
                                    color="blue"
                                    )  {{ $i18n.t('trainer.trainer_gamePlayBox_clear') }}
                                cs-button.play-box__next-example-button(
                                    v-if="!isDictationMode && isCorrectAnswerChosen",
                                    @click="nextExample",
                                    pattern="primary-outline",
                                    color="blue"
                                    )  {{ $i18n.t('olympiads.olympiads_processStage_further') }}
                                cs-button.play-box__next-example-button(
                                    v-if="!isDictationMode && !isCorrectAnswerChosen",
                                    @click="processReply(false)"
                                    pattern="primary-outline",
                                    color="blue"
                                )  {{ $i18n.t('trainer.trainer_gamePlayBox_check') }}
                .game-info__block(v-if="!isOrientationChanged && gameStarted && !gameFinished")
                        game-info(
                            :score="{left: answers.good, right: answers.bad}"
                            :time="getTime"
                            :slug="type"
                            :parameters="parameters"
                            :game-allows-tips="true"
                            :game-allows-description="true"
                            :opponent="opponent"
                            :opponent-numbers="opponentNumbers"
                            :is-opponent-answering="isOpponentAnswering"
                            :is-from-battle="isBattle"
                            :is-olympiad="isOlympiad"
                        )
                .divide-it-right__answer-buttom(v-if='isDictationMode && gameFinished && !showAnswersInDictationMode')
                    img.divide-it-right__answer-turtle(:src="turtle")
                    cs-button(@click='showAnswerInDictationMode' v-focus='')
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}
                examples-viewer(
                    v-if="!isOrientationChanged && showAnswersInDictationMode"
                    :examples-array="examplesArrayForDicationMode"
                )
                .play-box__end-container(v-if='gameFinished && !isOlympiad && !isDictationMode')
                    fireworks(
                        v-if="gameFinished && !isOlympiad && gameResult === 'success' "
                        :is-mobile="isMobile"
                    )
                    .play-box__reaction-container
                            .play-box__answers.play-box__answers--left
                                | {{ $i18n.t('trainer.trainer_game_wordField_yourTime') }}
                                br
                                | {{ getTime }}
                            result-image.play-box__image(:status="gameResult")
                            .play-box__answers.play-box__answers--right
                                | {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                br
                                | {{ answers.good }} / {{ answers.bad }}
                    result-buttons(
                        v-if="!isBattle"
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
                calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import WordStructureItems from '../../../../api/games/wordStructureGameItems';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import Battle from '../../../../utils/battle/battleMixin';
    import olympiadRussianLanguageAnswerTimerMixin from '../../../../utils/olympiads/olympiadRussianLanguageAnswerTimerMixin.js';
    import { cloneDeep, uniq } from 'lodash';
    import CsButton from '@/elements/CsButton.vue';
    import CsLoader from '@/elements/CsLoader.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import ExamplesViewer from './ExamplesViewer.vue';
    import deleteDuplicateObjectsInArray from "@/utils/deleteDuplicateObjectsInArrayMixin";
    import {windowDimensions} from "@/utils/windowDimensions";

    const Core = () => import('./svg-components/Core.vue');
    const Ending = () => import('./svg-components/Ending.vue');
    const Prefix = () => import('./svg-components/Prefix.vue');
    const Suffix = () => import('./svg-components/Suffix.vue');
    const Root = () => import('./svg-components/Root.vue');
    const NullableEnding = () => import('./svg-components/NullableEnding.vue')


    function DEFAULT_DATA() {
        return {
            examples: null,
            fontSize: '6',
            currentLevel: 0,
            answers: { good: 0, bad: 0 },
            isCorrectAnswerChosen: false,
            showAnswersInDictationMode: false,
            wholeWordForCurrentExample: null,
            userAnswers: [],
            userChosenLetters: [],
            dataForCurrentExample: null,
            nullableEndingChosen: false,
            isNullableEndingRight: false,
            letterBlockWidth: null,
            letterBlockHeight: null,
            isVerticalScreen: false,
            isOrientationChanged: false,
            initialOrientationIsVertical: false,
        };
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, olympiadRussianLanguageAnswerTimerMixin, Battle, deleteDuplicateObjectsInArray],
        data() {
            return DEFAULT_DATA();
        },
        created() {
            this.$nextTick(this.onResize);
        },
        mounted() {
            window.addEventListener('resize', this.onResize);
            document.addEventListener('keydown', this.handleKeyPress);
            this.initialOrientationIsVertical = windowDimensions().isVerticalScreen;
        },
        beforeDestroy() {
            this.beforeTabClosed();
            document.removeEventListener('keydown', this.handleKeyPress);
            window.removeEventListener('beforeunload', this.beforeTabClosed);
            window.removeEventListener('resize', this.onResize);

        },
        watch: {
            isVerticalScreen() {
                this.isOrientationChanged = this.initialOrientationIsVertical
                    ? this.initialOrientationIsVertical !== this.isVerticalScreen
                    : this.isVerticalScreen;
            },
            time: {
                handler(val) {
                    if (
                        this.parameters?.timeLimit !== 0 &&
                        val >= this.parameters?.timeLimit * 60 &&
                        !this.gameFinished
                    ) {
                        this.finishGame();
                    }
                    if (this.isDictationMode && val % this.parameters?.timeForAnswer === 0) {
                        this.nextExample();
                    }
                },
            },
        },
        computed: {
            possibleAnswers () {
                const arr = this.parameters.selectedParts.map(obj => obj.value);
                if (arr.includes('ending')) {
                    arr.push('nullableEnding');
                }
                return arr;
            },
            isNullableEndingNeeded() {
                const arr = this.parameters.selectedParts.map(obj => obj.value);
                if (arr.includes('ending')) {
                    return true;
                } else {
                    return false;
                }
            },
            neededWordPartsForCurrentExample() {
                return this.dataForCurrentExample.wordParts.filter(obj => this.possibleAnswers.includes(obj.wordPart));
            },
            examplesArrayForDicationMode() {
                const arr = cloneDeep(this.examples);
                arr.length = this.parameters.amountOfExamples;
                return arr;
            },
            turtle() {
                return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            gameResult() {
                if (this.answers.good >= this.answers.bad) return 'success';
                else return 'failure';
            },
            elementName() {
                return 'play-box__field';
            },
            wordStyle() {
                return {
                    'font-size': this.fontSize + 'em',
                };
            },
            isDictationMode() {
                return this.parameters.dictation;
            },
            isInfiniteAmountOfExamples() {
                return this.parameters.timeLimit || this.parameters.infinityAmountOfExamples;
            },
        },
        methods: {
            onResize() {
                const data = windowDimensions();
                this.isVerticalScreen = data.isVerticalScreen;
            },
            getStylesForNullableEnding() {
                return {
                    left: this.$refs.letterBlocks[0].offsetWidth * this.wholeWordForCurrentExample.length,
                    top: 30
                }
            },
            getStylesForElements(userAnswer) {
                if (this.windowWidth >= 991) {
                    return {
                        left: `${userAnswer.startPosition}px`,
                        top: userAnswer.component === 'ending' ? 9 :
                            userAnswer.component === 'root' ? -20 :
                                userAnswer.component === 'core' ? 74 : 0
                    };
                }
                if (this.windowWidth <= 991 && this.windowWidth > 768) {
                    return {
                        left: `${userAnswer.startPosition}px`,
                        top: userAnswer.component === 'ending' ? 9 :
                            userAnswer.component === 'root' ? -20 :
                                userAnswer.component === 'core' ? 55 : 0
                    };
                }
                if (this.windowWidth <= 768) {
                    return {
                        left: `${userAnswer.startPosition}px`,
                        top: userAnswer.component === 'ending' ? 9 :
                            userAnswer.component === 'root' ? -20 :
                                userAnswer.component === 'core' ? 45 :
                                    userAnswer.component === 'suffix' ? -15 : 0
                    };
                }
            },
            clearUncheckedAnswers() {
                this.wholeWordForCurrentExample.forEach((obj, index) => {
                    if (!obj.isCorrect) {
                        obj.isChosen = false;
                        obj.isAnswered = false;
                    }
                });

                this.userAnswers = this.userAnswers.filter(obj => obj.isCorrect);
            },
            chooseUserAnswer(item) {
                if (this.shouldSkipUserAnswer(item)) return;

                const startPosition = this.findElementStartPosition();
                const letters = this.userChosenLetters.map(obj => obj.letter);
                const letterIndexes = this.userChosenLetters.map(obj => obj.letterIndex);
                this.changeFieldsInTheWholeWordEntity(item);
                const obj = {
                    component: item,
                    width: this.letterBlockWidth * this.userChosenLetters.length,
                    startPosition: startPosition * this.letterBlockWidth,
                    letters,
                    letterIndexes,
                    isCorrect: false,
                };
                this.userAnswers.push(obj);
                this.userChosenLetters = [];
            },
            shouldSkipUserAnswer(item) {
                if (this.userChosenLetters.length && item === 'nullableEnding') return true;
                if (!this.userChosenLetters.length && item === 'nullableEnding' && !this.isNullableEndingRight) {
                    this.nullableEndingChosen = !this.nullableEndingChosen;
                    return true;
                }
                if (!this.userChosenLetters.length) return true;
                if (this.isCorrectAnswerChosen) return true;
                return false;
            },
            changeFieldsInTheWholeWordEntity(item) {
                this.userChosenLetters.forEach(({letterIndex}) => {
                    this.wholeWordForCurrentExample[letterIndex].isAnswered = true;
                    this.wholeWordForCurrentExample[letterIndex].isChosen = false;
                })
            },
            findElementStartPosition() {
                const arrayOfValues = this.userChosenLetters.map(obj => obj.letterIndex);
                return Math.min.apply(null, arrayOfValues);
            },
            checkUserAnswer() {
                let arrayOfRightAnswers = this.dataForCurrentExample.wordParts;
                arrayOfRightAnswers = arrayOfRightAnswers.map(obj => ({
                    ...obj,
                        wordPartValue: obj.wordPartValue.split('')
                    })
                );

                this.userAnswers = this.removeDuplicateObjects(this.userAnswers);

                this.userAnswers.forEach(userAnswerObj => {
                    arrayOfRightAnswers.forEach(rightAnswerObj => {
                        const isValidAndCorrectUserAnswer = !userAnswerObj.isCorrect &&
                            rightAnswerObj.wordPart === userAnswerObj.component &&
                            userAnswerObj.letters.length === rightAnswerObj.wordPartValue.length &&
                            userAnswerObj.letters.every(letter => rightAnswerObj.wordPartValue.includes(letter))
                        if (isValidAndCorrectUserAnswer) {
                            userAnswerObj.isCorrect = true;
                            this.answers.good++;
                        }
                    })
                });

                this.answers.bad += this.userAnswers.filter(obj => !obj.isCorrect).length;
                this.userAnswers = this.userAnswers.filter(obj => obj.isCorrect);
                this.wholeWordForCurrentExample.forEach((obj) => obj.isChosen = false);

                this.checkForNullableEnding();

                this.userAnswers.forEach(({ letterIndexes }) => {
                    letterIndexes.forEach(letterIndex =>  {
                        this.wholeWordForCurrentExample[letterIndex].isCorrect = true;
                    })
                })

                this.isCorrectAnswerChosen = this.userAnswers.length === this.neededWordPartsForCurrentExample.length &&
                    this.userAnswers.every(obj => obj.isCorrect) &&
                    this.isNullableEndingRight;
            },
            checkForNullableEnding() {
                if (!this.isNullableEndingNeeded) {
                    this.isNullableEndingRight = true;
                    return;
                }
                if (this.isNullableEndingNeeded && !this.isNullableEndingRight) {
                    if (!!this.dataForCurrentExample.isNullable === this.nullableEndingChosen) {
                        this.isNullableEndingRight = true;
                        if (!!this.dataForCurrentExample.isNullable) {
                            this.answers.good++;
                        }
                    } else {
                        this.nullableEndingChosen = false;
                        this.answers.bad++;
                    }
                }
            },
            handleKeyPress(event) {
                if (event.key === 'Enter') {
                    if (!this.isDictationMode && !this.gameFinished) {
                        if (this.isCorrectAnswerChosen) {
                            return this.nextExample();
                        } else {
                            return this.processReply();
                        }
                    };
                }
            },
            chooseLetter(letter, letterIndex) {
                if (this.isDictationMode) return;
                if (!this.letterBlockWidth) {
                    this.letterBlockWidth = this.$refs.letterBlocks[0].offsetWidth;
                    this.letterBlockHeight = this.$refs.letterBlocks[0].offsetHeight;
                }
                if (this.isCorrectAnswerChosen) return;
                if (!this.isPossibleToChooseLetter(letterIndex)) return;
                if (letter.isChosen) {
                    this.userChosenLetters = this.userChosenLetters.filter((obj) =>
                        obj.letter !== letter.letter && obj.letterIndex !== letterIndex
                    );
                    return letter.isChosen = false;
                }
                this.userChosenLetters.push({letter: letter.letter, letterIndex});
                letter.isChosen = true;
            },
            isPossibleToChooseLetter(letterIndex) {
                const isAnyLetterChosen = this.wholeWordForCurrentExample.some(({ isChosen }) => isChosen);

                if (isAnyLetterChosen) {
                    const leftLetterChosen = this.wholeWordForCurrentExample[letterIndex - 1]?.isChosen;
                    const currentLetterChosen = this.wholeWordForCurrentExample[letterIndex].isChosen;
                    const rightLetterChosen = this.wholeWordForCurrentExample[letterIndex + 1]?.isChosen;

                    return leftLetterChosen || currentLetterChosen || rightLetterChosen;
                }

                return true;
            },
            showAnswerInDictationMode() {
                this.showAnswersInDictationMode = true;
            },
            registerSounds() {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
                this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
                this.$createjs.Sound.registerSounds(this.soundObjects);
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        const parts = this.parameters.selectedParts.map(obj => obj.value);
                        const classes = this.parameters.selectedClass.map(obj => obj.value);
                        WordStructureItems.getItemsByRequest({
                            isInfiniteAmountOfExamples: this.isInfiniteAmountOfExamples,
                            amountOfExamples: this.parameters.amountOfExamples,
                            classes,
                            parts
                        })
                            .then(data => {
                                this.examples = data;
                                this.generateExample();
                                this.startGame();
                                this.registerSounds();
                                this.isLoading = false;
                            })
                            .catch(e => this.showErrorMessage(e));
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            refreshGameStatBeforeSend() {
                this.gameStat.answers = this.answers.good;
                this.gameStat.amountOfMistakes = this.answers.bad;
                this.gameStat.attempts = this.answers.good + this.answers.bad;
                this.gameStat.isCompleted = this.isInfiniteAmountOfExamples ? true : this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.amountOfExamples = this.parameters.amountOfExamples;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            filterDataForCurrentExample() {
                let data = cloneDeep(this.examples[this.currentLevel]);
                data.wordParts =  data.wordParts.filter(obj => {
                    if (obj.wordPartValue === '' && obj.wordPart === 'ending') {
                        return false;
                    } else {
                        return true
                    }
                });

                return data;
            },
            generateExample() {
                this.dataForCurrentExample = this.filterDataForCurrentExample();
                this.wholeWordForCurrentExample = this.dataForCurrentExample.wholeWord.split('').map(letter => {
                    return {
                        letter,
                        isCorrect: false,
                        isChosen: false,
                        isAnswered: false,
                    }
                })
            },
            startGame() {
                this.gameStarted = true;
                this.startTimer();
            },
            startTimer() {
                this.startAnswerTimer();
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            processReply(finishExample = false) {
                if (finishExample) {
                    this.answers.bad++;
                    return this.nextExample();
                }
                if (this.isDictationMode) return;
                if (this.isCorrectAnswerChosen) return;
                this.checkUserAnswer();
                if (this.isOlympiad || this.isBattle) {
                    return this.nextExample();
                }
            },
            nextExample() {
                this.isCorrectAnswerChosen = false;
                this.stopAnswerTimer();
                if (!this.isInfiniteAmountOfExamples && this.currentLevel === this.parameters.amountOfExamples - 1) {
                    this.finishGame();
                    return;
                }
                this.currentLevel++;
                this.userAnswers = [];
                this.userChosenLetters = [];
                this.nullableEndingChosen = false,
                this.isNullableEndingRight = false,
                this.startAnswerTimer();
                this.generateExample();
            },
            finishGame() {
                this.gameFinished = true;
                this.stopTimer();
                if (!this.isDictationMode) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.sendStat();
                }
            },
            calculatePercent() {
                let total = this.answers.good + this.answers.bad;
                if (total > 0) {
                    return parseInt((this.answers.good / total) * 100);
                }
                return 0;
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            beforeTabClosed() {
                if (this.gameStarted) {
                    this.gameFinished = true;
                    this.sendStat();
                }
                return null;
            },
        },
        components: {
            ExamplesViewer,
            CsLoader,
            CsButton,
            CalculatingAnswers,
            Core,
            Root,
            Prefix,
            Suffix,
            Ending,
            NullableEnding,
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/playbox.scss';

    .play-box {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        width: 100%;
        align-items: center;
        flex-direction: column-reverse;
        @include media($md) {
            align-items: stretch;
            flex-direction: row;
        }
    }

    .mobile-version {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        width: 100%;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
        justify-content: center;
    }

    .play-box__overflow-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 7px;
        @include media($sm) {
            font-size: 8px;
        }
        @include media($md) {
            font-size: 9.5px;
        }
        @include media($lg) {
            font-size: 12px;
        }
        @include media($xl) {
            font-size: 13px;
        }
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__whole_words {
        display: flex;
        margin: 10px 0px;
    }

    .play-box__user_answers {
        position: relative;
    }

    .play-box__user_answer {
        position: absolute;
    }

    .play-box__whole_word {
        text-align: center;
        user-select: none;
        cursor: pointer;
        min-width: 10px;
        width: 30px;
        @include media($md) {
            width: 40px;
        }@include media($lg) {
            width: 55px;
        }
    }

    .chosen {
        background-color: #dcdcdc;
    }

    .play-box__words-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .answer-container__header {
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
    }

    .answer-container__input .cs-input {
        margin-bottom: 0;
        font-size: 52px;
        line-height: 62px;
        padding: 9px 15px;
        text-align: center;
        max-width: 330px;
    }

    .play-box__word {
        padding: 0 8px;
        margin: 0 10px 3px 0;
        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__word--inverted {
        display: inline-block;
        transform: rotate(180deg);
        margin-right: 10px;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-weight: 500;
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .play-box__before-start-game-header {
        flex-direction: column;
    }

    .play-box__task {
        align-self: center;
    }

    .play-box__title {
        margin-bottom: 20px;
        text-align: center;
    }

    .play-box__scaling-bar-block {
        margin-left: 20px;
        @include media($xlg) {
            margin-left: 40px;
        }
    }

    .play-box__subtitle {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;
        justify-content: center;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__answers--left {
        color: $hsl-color-green-58;
        margin-left: 20px;
        @include media($lg) {
            margin-left: 35px;
        }
    }

    .play-box__answers--right {
        color: $hsl-color-green-58;
        margin-right: 20px;
        @include media($lg) {
            margin-right: 35px;
        }
    }

    .play-box__answers--show-md {
        display: block;
    }

    .play-box__answers-container {
        display: flex;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 40px;
        @media screen and (max-width: 1200px) {
            height: 400px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 25px;
        justify-content: center;
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($lg) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .play-box__answers-field {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        gap: 10px;
        overflow-x: auto;
        width: 100%;
        @include media($xlg) {
            gap: 20px;
        }
    }

    .play-box__answer {
        cursor: pointer;
    }

    .play-box__next-example-button {
        margin-top: 15px;
    }

    .divide-it-right__answer-buttom {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .divide-it-right__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }
</style>
